/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'

import { AOSRJsonType, SecondaryActJsonType } from '../../Types/dataJSON'
import { getRelativeSizePt } from '../molecules/basis'
import { H1 } from '../molecules/H1'
import { Paragraph } from '../molecules/Paragraph'
import { SubDescription } from '../molecules/SubDescription'
import {
  IActTemplate,
  IFrontPageSection,
  IHeaderActSection,
  IInlineActSection,
  IPageSeparatorActSection,
  ISelectActSection,
  ISubHeaderActSection,
  ITableActSection,
  ITextActSection,
  ITextTemplateActSection,
  RowDataType,
} from '../template.type'

type InlineType = {
  section: IInlineActSection
  actItems: AOSRJsonType | SecondaryActJsonType
  selectedField?: any
  getValue: ({
    value,
    sectionTemplate,
    template,
  }: {
    value: string | RowDataType[][]
    sectionTemplate:
      | IHeaderActSection
      | IInlineActSection
      | ITextTemplateActSection
      | ITableActSection
      | IFrontPageSection
      | ISelectActSection
      | IPageSeparatorActSection
      | ITextActSection
      | ISubHeaderActSection
    template?: IActTemplate
  }) => string | Array<Array<RowDataType>>
  onToggle: (
    item: (
      | IInlineActSection
      | ITextTemplateActSection
      | ISelectActSection
      | ITextActSection
    ) & { value: string },
  ) => void
  subDescriptionFontSize?: string
  paragraphFontSize?: string
}

export const Inline = ({
  section,
  actItems,
  selectedField,
  paragraphFontSize,
  subDescriptionFontSize,
  onToggle,
  getValue,
}: InlineType) => {
  return (
    <div
      css={css`
        width: ${section.styles?.width};
        display: flex;
        justify-content: ${section.styles?.align
          ? section.styles.align
          : 'space-between'};
        align-items: baseline;
        margin-top: ${getRelativeSizePt(8)};
      `}
    >
      {section.items.map(item => (
        <div
          key={item.key}
          css={css`
            display: flex;
            justify-content: left;
            align-items: baseline;
            flex-grow: ${section.styles?.align &&
            section.styles.align === 'stretch'
              ? 1
              : 0};
          `}
        >
          <H1
            css={css`
              display: inline;
              font-weight: ${section.styles?.fontWeight};
            `}
          >
            {item.title}
          </H1>
          <div
            css={css`
              padding-left: ${getRelativeSizePt(4)};
              padding-right: ${getRelativeSizePt(4)};
              flex-grow: ${section.styles?.align &&
              section.styles.align === 'stretch'
                ? 1
                : 0};
              align-self: ${getValue({
                value: actItems[item.key]?.value as string,
                sectionTemplate: item,
              })
                ? 'baseline'
                : 'flex-end'};
            `}
          >
            <Paragraph
              fontSize={paragraphFontSize}
              id={item.key}
              isEditable={Boolean(item?.editable)}
              selectedId={selectedField}
              underlined={item.styles?.underlined && item.styles?.underlined}
              onToggle={() => onToggle({ ...item, value: '' })}
            >
              {getValue({
                value: actItems[item.key]?.value as string,
                sectionTemplate: item,
              })}
            </Paragraph>

            {item.sub_description && (
              <SubDescription fontSize={subDescriptionFontSize}>
                {item.sub_description && item.sub_description}
              </SubDescription>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
